import * as React from 'react';
import { Link } from 'react-router-dom';

import Utils, { Validation, InputError } from '../../common/utils';

import { TextInput } from '../../components/forms';
import { Button } from '../../components/buttons';
import { Spinner } from '../../components/common';

interface Props {
	referrals: CustomerReferralResponse;
	currentUser: UserDetails;
	onInvite: (name: string, email: string, resetForm: Function) => void;
	disabled: boolean;
	isSubmitting: boolean;
	fullFormWidth?: boolean;
}
interface State {
	name: string;
	email: string;
	touched: {
		email: boolean;
	};
}
class FriendReferral extends React.Component<Props, State> {
	errors = { email: {} as InputError };
	state = {
		name: '',
		email: '',
		touched: {
			email: false
		}
	};

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}
	validate = () => {
		// true means invalid
		return {
			email: Validation.validateEmail(this.state.email)
		};
	}
	isInviteDisabled = () => {
		return !this.state.name ||
		!this.state.email ||
		this.errors.email.hasError ||
		this.state.email === this.props.currentUser.email;
	}
	resetForm = () => {
		this.setState({name: '', email: '', touched: {email: false}} );
	}

	public render() {
		this.errors = this.validate();
		return (
			<div className="border px-3 py-4 p-lg-4 d-flex flex-column justify-content-center w-100">
				{this.props.referrals.remainingReferrals !== undefined && this.props.referrals.remainingReferrals > 0 ? (
					<div className="text-center">
						<p>
							<strong>
								Refer a friend and you each get a credit of up to $25!
							</strong>
						</p>
						<p>
							({this.props.referrals.remainingReferrals}
								{this.props.referrals.remainingReferrals === 1 ? ' referral' : ' referrals'} left to claim)
							Your code is: <strong>{this.props.referrals.referralCode || '-'}</strong>
						</p>
					</div>
				) : (
					<p className="mb-0 text-center">
						All friend referrals have been claimed. 
						Call us at <a href="tel:1-855-643-6945">1-855-643-6945</a> or <Link to="/contact-us">contact us</Link>{' '}
						to see if you are eligible for more referrals.
					</p>
				)}
				{
					this.props.referrals.remainingReferrals !== undefined && this.props.referrals.remainingReferrals > 0 ? (
					<div className="row">
						<TextInput
							labelText="Name"
							name="name"
							placeholder="John Smith"
							value={this.state.name}
							onChange={(e: any) => this.setState({ name: e.target.value })}
							className={this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0 ml-md-auto'}
						/>
						<TextInput
							labelText="Email"
							name="email"
							placeholder="john@example.com"
							value={this.state.email}
							onBlur={this.handleBlur('email')}
							onChange={(e: any) => this.setState({ email: e.target.value })}
							className={this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0'}
							error={Utils.shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined}
						/>
						<div className={this.props.fullFormWidth ? 'col-12' : 'col-md-auto align-self-end mr-md-auto'}>
							<Button
								className="btn-primary" 
								onClick={() => this.props.onInvite(this.state.name, this.state.email, this.resetForm)} 
								disabled={this.props.disabled || this.isInviteDisabled()}
							>
								Send Invite
								{this.props.isSubmitting && <Spinner />}
							</Button>
						</div>
					</div>
					) : (
						''
					)
				}
			</div>
		);
	}
}
export default FriendReferral;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/referral/FriendReferral.tsx